// Libs
import React, { useEffect, useState, useMemo } from 'react';
import { Collapse, Icon } from 'antd';

// Own Libs
import * as ui from '@digital/ui';

//Api
import {
  CrfCicloOrcamentarioProjetoPacote,
  getCicloOrcamentarioProjetoPacotePluriAnual,
  getCicloOrcamentarioProjetoPacotePluriAnualExportaExcel,
  getCicloOrcamentarioProjetoPacotePluriAnualTabela,
} from '@app/api/crf/CrfRelatorioCicloorcamentario';

//Files
import AbaPacoteTabela from './AbaPacoteTabela';
import { getFileADistribuirByCrfProjetoId } from '@app/api/crf/crfADistribuir';

//Utils

const { Panel } = Collapse;

interface tipoColuna {
  colunaPrincipal: string;
  colunaSegundaria: string;
  valor: string;
  descricaoDataIndex: string;
}
interface PropAbaPacote {
  projetoId: string;
  pageSize: number;
  projetoCodigo?: string;
  mostrarBotalExportarADistribuir: boolean;
  nomeProjeto: string;
}

const AbaPacote = (props: PropAbaPacote) => {
  const { projetoId, pageSize, projetoCodigo, mostrarBotalExportarADistribuir, nomeProjeto } = props;
  const [totalizador, setTotalizador] = useState<tipoColuna[]>([]);
  const [cicloOrcamentarioProjetoPacotePluriAnual, setCicloOrcamentarioProjetoPacotePluriAnual] = useState<CrfCicloOrcamentarioProjetoPacote>();

  const [valorTotalA, setValorTotalA] = useState('0');
  const [valorTotalB, setValorTotalB] = useState('0');
  const [valorTotalC, setValorTotalC] = useState('0');
  const [valorTotalD, setValorTotalD] = useState('0');
  const [valorTotalE, setValorTotalE] = useState('0');
  const [valorTotalF, setValorTotalF] = useState('0');
  const [valorTotalG, setValorTotalG] = useState('0');
  const [valorTotalH, setValorTotalH] = useState('0');


  const calcularTotal = (() => {
    if (cicloOrcamentarioProjetoPacotePluriAnual) {
      setValorTotalA(cicloOrcamentarioProjetoPacotePluriAnual.valorTotalA);
      setValorTotalB(cicloOrcamentarioProjetoPacotePluriAnual.valorTotalB);
      setValorTotalC(cicloOrcamentarioProjetoPacotePluriAnual.valorTotalC);
      setValorTotalD(cicloOrcamentarioProjetoPacotePluriAnual.valorTotalD);
      setValorTotalE(cicloOrcamentarioProjetoPacotePluriAnual.valorTotalE);
      setValorTotalF(cicloOrcamentarioProjetoPacotePluriAnual.valorTotalF);
      setValorTotalG(cicloOrcamentarioProjetoPacotePluriAnual.valorTotalG);
      setValorTotalH(cicloOrcamentarioProjetoPacotePluriAnual.valorTotalH);
    }
  });

  useEffect(calcularTotal, [cicloOrcamentarioProjetoPacotePluriAnual]);


  useMemo(() => {
    if (projetoId) {
      getCicloOrcamentarioProjetoPacotePluriAnualTabela(projetoId).then(data => {
        setCicloOrcamentarioProjetoPacotePluriAnual(data);
        calcularTotal();
      });
    }
  }, [projetoId]);


  useEffect(() => {
    if (cicloOrcamentarioProjetoPacotePluriAnual) {
      let array = [
        {
          colunaPrincipal: 'A',
          colunaSegundaria: 'Orçado',
          valor: `${valorTotalA}`,
          descricaoDataIndex: 'orcadoAnoFormatado',
        },
        {
          colunaPrincipal: 'B',
          colunaSegundaria: 'Contratado',
          valor: `${valorTotalB}`,
          descricaoDataIndex: 'contratadoFormatado',
        },
        {
          colunaPrincipal: 'C',
          colunaSegundaria: 'Executado',
          valor: `${valorTotalC}`,
          descricaoDataIndex: 'executadoFormatado',
        },
        {
          colunaPrincipal: 'D',
          colunaSegundaria: 'Requisitado',
          valor: `${valorTotalD}`,
          descricaoDataIndex: 'requisitadoFormatado',
        },
        {
          colunaPrincipal: 'E = B - C + D',
          colunaSegundaria: 'Compromissado',
          valor: `${valorTotalE}`,
          descricaoDataIndex: 'compromissadoFormatado',
        },
        {
          colunaPrincipal: 'F',
          colunaSegundaria: 'A Contratar',
          valor: `${valorTotalF}`,
          descricaoDataIndex: 'aContratarFormatado',
        },
        {
          colunaPrincipal: 'G = B + D + F',
          colunaSegundaria: 'Forecast',
          valor: `${valorTotalG}`,
          descricaoDataIndex: 'forcastFormatado',
        },
        {
          colunaPrincipal: 'H = A - G',
          colunaSegundaria: 'Saldo',
          valor: `${valorTotalH}`,
          descricaoDataIndex: 'saldoFormatado',
        },
      ] as tipoColuna[];
      setTotalizador(array);
    } else {
      setTotalizador([]);
    }
  }, [
    cicloOrcamentarioProjetoPacotePluriAnual,
    valorTotalA,
    valorTotalB,
    valorTotalC,
    valorTotalD,
    valorTotalE,
    valorTotalF,
    valorTotalG,
    valorTotalH
  ]);


  const handleFilterExportar = () => {
    if (projetoId)
      getCicloOrcamentarioProjetoPacotePluriAnualExportaExcel(projetoId);
  }

  const hasExportar = () => {
    getFileADistribuirByCrfProjetoId(projetoId, nomeProjeto)
  }

  const btnExportar = () => {
    if (mostrarBotalExportarADistribuir === true) {
      return [
        <ui.Button
          type="link"
          name="btnExportar"
          icon="files-ms_excel"
          onClick={() => {
            hasExportar();
          }}>
          <ui.FormatText id="data-export" uppercase transform={() => "Exportar Relatório Detalhado"} />
        </ui.Button>,
        <ui.Button
          type="primary"
          name="btnExportar"
          icon="files-ms_excel"
          onClick={() => {
            handleFilterExportar()
          }}>
          <ui.FormatText id="data-export" uppercase transform={() => "Exportar Relatório"} />
        </ui.Button>,
      ]
    }

    return [
      <ui.Button
        type="primary"
        name="btnExportar"
        icon="files-ms_excel"
        onClick={() => {
          handleFilterExportar()
        }}>
        <ui.FormatText id="data-export" uppercase transform={() => "Exportar Relatório"} />
      </ui.Button>,
    ]
  }




  return (
    <>
      {totalizador && cicloOrcamentarioProjetoPacotePluriAnual ? (
        <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="1" header="PACOTE PLURIANUAL" style={{ border: 0 }}>
            <ui.Widget actions={btnExportar()}>
              <AbaPacoteTabela
                projetoId={projetoId}
                pageSize={pageSize}
                cicloOrcamentarioProjetoPacotePluriAnual={cicloOrcamentarioProjetoPacotePluriAnual}
              />
            </ui.Widget>
          </Panel>
        </Collapse>
      ) : (
        <> </>
      )}
    </>
  );
};

export default AbaPacote;
